import {Pipe, PipeTransform} from '@angular/core';
import {Store} from '@ngxs/store';
import {User} from '../../models/users/user.model';
import {UsersState} from '../../state/users.state';

@Pipe({
  standalone: false,
  name: 'user'
})
export class UserResolvePipe implements PipeTransform {
  private readonly users: User[];

  constructor(private store: Store) {
    this.users = this.store.selectSnapshot(UsersState.users);
  }

  transform(value: any): string {
    if (value === null || value === undefined || value === '' || this.users?.length === 0) {
      return null;
    }
    const user = this.users.find(u => u.id === value);
    return user ? user.name : null;
  }

}
